<form (submit)="guardar($event)" class="space-y-3 sm:space-y-4 w-full max-w-full">
  <!-- Campo Nombre -->
  <div class="space-y-1 sm:space-y-2">
    <label for="nombre" class="block text-xs sm:text-sm font-medium text-gray-700"> Nombre </label>
    <input
      id="nombre"
      type="text"
      [formField]="$any(categoriaForm.nombre)"
      placeholder="Ej: Electrónica"
      class="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition text-sm sm:text-base"
    />
    @if (categoriaForm.nombre().touched() && categoriaForm.nombre().invalid()) {
      <small class="p-error">El nombre es requerido</small>
    }
  </div>

  <!-- Campo Descripción -->
  <div class="space-y-1 sm:space-y-2">
    <label for="descripcion" class="block text-xs sm:text-sm font-medium text-gray-700">
      Descripción
    </label>
    <textarea
      id="descripcion"
      [formField]="$any(categoriaForm.descripcion)"
      placeholder="Describe la categoría..."
      rows="4"
      class="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition resize-none text-sm sm:text-base"
    ></textarea>
    @if (categoriaForm.descripcion().touched() && categoriaForm.descripcion().invalid()) {
      <small class="p-error">La descripción es requerida</small>
    }
  </div>

  <!-- Botones -->
  <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 pt-3 sm:pt-4">
    <button
      type="button"
      class="w-full sm:flex-1 px-4 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 active:scale-95 transition-all text-sm sm:text-base"
      (click)="onCerrar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="w-full sm:flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 active:scale-95 transition-all text-sm sm:text-base"
    >
      Guardar
    </button>
  </div>
</form>
